export default {
  title: "Sources of recommendations",
  description:
    "Shyft is Lifestyle management and tracking for specific health conditions like chronic ailments, pregnancy care, chronic pains, and more. While encouraging your understanding of what nutrition, exercise, and healthy habits can do for you, always consult a doctor or healthcare professional for medical advice and treatments before making any medical decisions.",
  sections: [
    {
      title: "Prenatal Care",
      sources: [
        {
          source: "Nutrition during Pregnancy",
          link: "https://www.acog.org/womens-health/faqs/nutrition-during-pregnancy",
        },
        {
          source: "Nutrition Recommendations in Pregnancy and Lactation",
          link: "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC5104202/",
        },
        {
          source: "Contraindications for vitamin A supplementation",
          link: "https://www.ncbi.nlm.nih.gov/",
        },
      ],
    },
    {
      title: "Postnatal",
      sources: [
        {
          source: "Importance of Vitamin B12 in breastfeeding mothers",
          link: "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC6008958/",
        },
        {
          source: "Importance of Vitamin B3 in cognitive function",
          link: "https://www.hsph.harvard.edu/nutritionsource/niacin-vitamin-b3/",
        },
        {
          source: "Importance of vitamin B1 in breastfeeding mothers",
          link: "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4757446/",
        },
      ],
    },
    {
      title: "PCOS",
      sources: [
        {
          source: "Correlation between gut microbiome & PCOS",
          link: "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC8643565/",
        },
        {
          source: "Role of vitamins & minerals in PCOS",
          link: "https://www.mdpi.com/2072-6643/13/7/2452",
        },
        {
          source: "Relation of nutrients and hormones in PCOS",
          link: "https://pubmed.ncbi.nlm.nih.gov/17344488/",
        },
        {
          source: "Dairy intake & PCOS",
          link: "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC7696580/",
        },
      ],
    },
    {
      title: "High BP",
      sources: [
        {
          source: "Management of primary HTN in India ( 2016 update)",
          link: "https://nhm.gov.in/images/pdf/guidelines/nrhm-guidelines/stg/Hypertension_full.pdf",
        },
        {
          source: "Dietary guidelines for Indians with hypertension",
          link: "https://idaindia.com/wp-content/uploads/2020/11/Hypertension-Toolkit-2020.pdf",
        },
        {
          source: "DASH guidelines for macro & micro nutrient intake",
          link: "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4366416/",
        },
      ],
    },
    {
      title: "Diabetes",
      sources: [
        {
          source:
            "International Diabetes Federation - Global Guidelines for Type 2 Diabetes",
          link: "https://idf.org/e-library/guidelines/79-global-guideline-for-type-2-diabetes.html",
        },
        {
          source: "Effect of Diet on Type 2 Diabetes",
          link: "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC5426415/",
        },
        {
          source:
            "Nutritional Recommendations (food groups distribution) for Individuals with Diabetes",
          link: "https://www.ncbi.nlm.nih.gov/books/NBK279012/",
        },
      ],
    },
    {
      title: "Thyroid",
      sources: [
        {
          source: "Complete overview for hypothyroidism",
          link: "https://www.ncbi.nlm.nih.gov/books/NBK519536/",
        },
        {
          source: "Vitamin D & hypothyroidism",
          link: "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3921055/",
        },
        {
          source: "Role of micronutrients in thyroid dysfunction",
          link: "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC7282437/",
        },
      ],
    },
    {
      title: "General",
      sources: [
        {
          source: "Nutrition Guidelines for Indians - ICMR",
          link: "https://www.nin.res.in/downloads/DietaryGuidelinesforNINwebsite.pdf",
        },
        {
          source:
            "Adverse Effects Associated with Protein Intake above the Recommended Dietary Allowance for Adults",
          link: "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4045293/",
        },
        {
          source: "Role of calcium in human aging",
          link: "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4337919/",
        },
      ],
    },
    {
      title: "Cholesterol",
      sources: [
        {
          source: "Importance of Vitamin B3 in the treatment of dyslipidemia",
          link: "https://www.ncbi.nlm.nih.gov/books/NBK526107/",
        },
        {
          source: "Overview of Hypertriglyceridemia",
          link: "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC5872265/",
        },
        {
          source:
            "Importance of Vitamin E against hypercholesterolemia-induced age-related diseases",
          link: "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3250520/",
        },
        {
          source: "Importance of Vitamin D in cholesterol management",
          link: "https://pubmed.ncbi.nlm.nih.gov/31407792/",
        },
        {
          source: "Selecting the right edible oil in the Indian context",
          link: "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4990724/",
        },
      ],
    },
    {
      title: "Weight Management",
      sources: [
        {
          source: "Understanding BMI",
          link: "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4890841/",
        },
        {
          source:
            "Weight loss maintenance: A review on dietary related strategies",
          link: "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4061651/",
        },
        {
          source: "Myths about food types & intake",
          link: "https://www.niddk.nih.gov/health-information/weight-management/myths-nutrition-physical-activity",
        },
        {
          source:
            "Weight gain attempts and diet modification efforts among adults in five countries: a cross-sectional study",
          link: "https://nutritionj.biomedcentral.com/articles/10.1186/s12937-022-00784-y",
        },
      ],
    },
    {
      title: "Gut Health",
      sources: [
        {
          source: "Role of B vitamins in the management of gut health",
          link: "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC9227236/",
        },
        {
          source:
            "Role of prebiotics in the the stimulation of healthy gut bacteria",
          link: "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC6463098/",
        },
        {
          source: "Low-FODMAP Diet",
          link: "https://www.ncbi.nlm.nih.gov/books/NBK562224/",
        },
        {
          source: "Gut Microbiota, Immunity & Health",
          link: "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC6020729/",
        },
      ],
    },
  ],
};
